'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Message = undefined;
var _systemComponents = require('system-components');
var _systemComponents2 = _interopRequireDefault(_systemComponents);
var _gridStyled = require('grid-styled');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var Message = exports.Message = (0, _systemComponents2["default"])({
  is: _gridStyled.Flex,
  px: 3,
  py: 2,
  fontWeight: 'bold',
  color: 'white',
  bg: 'blue',
  align: 'center',
  minHeight: '48px'
}, 'minHeight', {
  WebkitFontSmoothing: 'antialiased'
});
Message.displayName = 'Message';
exports["default"] = Message;